import AnnouncerMember from './AnnouncerMember'

export default AnnouncerMember